import axios from 'axios';
import { NikeWebCommon } from '../../types/generated/nike-web-common';
import { goalOfMonthClient } from '../../common/axios/goalOfMonthClient';
import { GoalOfMonthApi } from './types';
import { getGoalOfMonthConfig, getGomArticle, isGomCompetitionActive } from './utils';

export function getTvNovinyVoteUrl(voteRequestDTO: NikeWebCommon.GoalOfMonthVoteRequestDTO) {
    return axios.post<any, NikeWebCommon.GoalOfMonthVoteResponseDTO>('/api/goalofmonth', voteRequestDTO);
}

export async function getGomDetail() {
    const response = await goalOfMonthClient.get<never, GoalOfMonthApi.GoalOfMonthDetailResponse>(
        getGoalOfMonthConfig().liveDataDetailEndpointUrl
    );
    const section = response?.sections[0];
    return {
        sortedPlayers: section?.sortedItems,
        players: section?.items,
        competitionId: section?.data?.competitionId,
        title: section?.sortedItems?.[0]?.pluginData.title
    };
}

export async function getIsGomActive() {
    const response = await goalOfMonthClient.get<never, GoalOfMonthApi.GoalOfMonthDriverResponse>(
        getGoalOfMonthConfig().liveDataDriverEndpointUrl
    );
    return isGomCompetitionActive(response?.competition);
}

export async function getGoalOfMonthData() {
    const isActive = await getIsGomActive();
    const resultArticle = await getGomArticle(getGoalOfMonthConfig().resultArticleNiceUrl);
    if (isActive) {
        const detail = await getGomDetail();
        return {
            isActive: true,
            article: resultArticle,
            ...detail
        };
    }
    return {
        isActive: false,
        players: {},
        sortedPlayers: [],
        competitionId: '',
        title: '',
        article: resultArticle
    };
}
